import React from 'react';
import PropTypes from 'prop-types';
import { TextValidator, ValidatorForm } from 'react-material-ui-form-validator';

import Constants from "../utils/Constants";
import StandardFormLayout from './StandardFormLayout';
import PasswordField from "./PasswordField";
import LoginHelpButton from "./LoginHelpButton";
import LogoPrimary from "../assets/detect-v2-left-aligned.svg";
import LogoSecondaryLight from "../assets/detect-logo-dark-color.png";

import ClassLinkImage from '../assets/classlink-image.png';
import CleverImage from '../assets/clever-image.png';

import {
	makeStyles,
	Button,
	FormHelperText,
	Typography,
	Grid,
	Box,
	Divider
} from '@material-ui/core';
import LabeledTextValidator from './LabeledTextValidator';

const topLogoSize = { width: 250, height: 50 };

const styles = makeStyles(theme => ({
	submitBtnWrapper: {
		display: "flex",
		justifyContent: "center"
	},

	helperText: {
		display: "block"
	},

	container: {
		margin: "30px 135px 20px 100px"
	},

	primary: {
		width: topLogoSize.width,
		height: topLogoSize.height,
		backgroundSize: topLogoSize.width,
		background: 'url("' + LogoPrimary + '") no-repeat center',
		paddingBottom: 50,
	},

	secondaryLight: {
		width: topLogoSize.width,
		height: topLogoSize.height,
		backgroundSize: `200px`,
		background: 'url("'+LogoSecondaryLight+'") no-repeat center',
		marginTop: 30,
	},

	heading: {
		fontSize: 30,
		fontFamily: "Merriweather",
		fontWeight: 400,
		lineHeight: "38px", 
	}, 

	forgotPassword: {
		width: "100%",
		color: theme.palette.primary.main,
		textAlign: "center",
		fontSize: 14,
		fontWeight: 700,
		margin: "10px auto",
		cursor: "pointer",
	}, 

	buttonLink: {
		borderColor: '#99CBD2',
	}
}));

function LoginForm(props) {
	// Convert the submitted form even to an object of values instead
	const handleSubmit = (event) => {
		let form = event.target;
		let values = {
			id: props.formValues.id,
		};

		Object.keys(form.elements).map(e => {
			// Don't send if element not named
			if (form.elements[e].nodeName && form.elements[e].name) {
				values[form.elements[e].name] = form.elements[e].value;
			}

			return e;
		});

		props.handleSubmit(values);
	};

	let classes = styles(),		
		{ handleChange, handleForgotToggle, formValues, redirectToSignupHandler } = props,
		{ email, password } = formValues;

	return (
		<div className={classes.container}>
			<div className={classes.primary} alt="" />
			<Typography className={classes.heading}>Sign in to your account</Typography>
			<ValidatorForm
				method="post"
				action="./"
				debounceTime={500}
				onSubmit={handleSubmit}>
				<StandardFormLayout submitOnKeyPress>
					<LabeledTextValidator
						fullWidth
						autoFocus
						id="email"
						variant="outlined"
						label={<>
							Email <span style={{ color: 'red' }}>*</span>
						</>}
						name="email"
						helperText="Email address or username for login"
						margin="normal"
						value={email || ''}
						inputProps={{
							autoCapitalize: "off",
							autoComplete: "username"
						}}
						onChange={handleChange}
						validators={['required']}
						errorMessages={[Constants.ERROR_MESSAGES['required']]} />
					<LabeledTextValidator
						fullWidth
						id="password"
						label={<>
							Password <span style={{ color: 'red' }}>*</span>
						</>}
						name="password"
						margin="normal"
						variant="outlined"
						type="password"
						inputProps={{
							'aria-describedby': "password-field-helper-text"
						}}
						value={password || ''}
						// helperText={
						// 	<LoginHelpButton
						// 		handleClick={handleForgotToggle}>Forgot Password?</LoginHelpButton>
						// }
						// FormHelperTextProps={{
						// 	className: classes.helperText,
						// 	component: 'div'
						// }}
						onChange={handleChange}
						validators={['required']} />

						<Button
							fullWidth
							id="submit"
							type="submit"
							variant="contained"
							color="primary">Login</Button>

						<Typography className={classes.forgotPassword} onClick={handleForgotToggle}>Forgot Password?</Typography>
						{/* <Typography className={classes.forgotPassword} onClick={redirectToSignupHandler}>Create new account</Typography> */}
						<Typography />				
				</StandardFormLayout>
				<FormHelperText id="password-field-helper-text">Password for login</FormHelperText>
			</ValidatorForm>
		</div>
	);
}

LoginForm.propTypes = {
	handleChange: PropTypes.func.isRequired,
	handleSubmit: PropTypes.func.isRequired,
	handleForgotToggle: PropTypes.func,
	formValues: PropTypes.object.isRequired
};

export default LoginForm;
